<template>
  <div class="prefooter" id="prefooter">
    <b-container>
      <b-row>
        <b-col sm="6" md="6" lg="3">
          <div class="prefooter--block">
            <div class="prefooter--icon" v-html="clock"></div>
            <div class="prefooter--text">
              <div class="prefooter--title">
                <div class="d-block nowrap">Assistenza</div>
                <div class="d-block nowrap">Lun-Ven 9:00-19:00</div>
              </div>
            </div>
          </div>
        </b-col>
        <!--<b-col sm="6" md="6" lg="3">
                    <div class="prefooter--block">
                        <div class="prefooter--icon" v-html="faq"></div>
                        <div class="prefooter--text">
                            <div class="prefooter--title">
                                Domande frequenti
                            </div>
                            <div class="prefooter--link">
                                <router-link :to="{name: 'faq'}">
                                    Leggi
                                    <div class="chevron-right" v-html="chevron_right"></div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </b-col>-->
        <!--<b-col sm="6" md="6" lg="3" v-if="config.site.waIntentLink">
                    <div class="prefooter--block">
                        <div class="prefooter--icon" v-html="whatsapp"></div>
                        <div class="prefooter--text">
                            <div class="prefooter--title">
                                Whatsapp
                            </div>
                            <div class="prefooter--link">
                                <a v-bind:href="config.site.waIntentLink">
                                    Chatta ora
                                    <div class="chevron-right" v-html="chevron_right"></div>
                                </a>
                            </div>
                        </div>
                    </div>
                </b-col>-->
        <b-col sm="6" md="6" lg="3" v-if="config.site.emailSupport">
          <div class="prefooter--block">
            <div class="prefooter--icon" v-html="mail"></div>
            <div class="prefooter--text">
              <div class="prefooter--title">Assistenza email</div>
              <div class="prefooter--link">
                <a v-bind:href="'mailto:' + config.site.emailSupport">
                  {{ config.site.emailSupport }}
                </a>
              </div>
            </div>
          </div>
        </b-col>
        <b-col sm="6" md="6" lg="3" v-if="config.site.phoneNumber">
          <div class="prefooter--block">
            <div class="prefooter--icon" v-html="phone"></div>
            <div class="prefooter--text">
              <div class="prefooter--title">
                {{ config.site.phoneNumber }}
              </div>
              <div class="prefooter--link">
                <a v-bind:href="'phone:' + config.site.phoneNumber">
                  Chiama ora
                  <div class="chevron-right" v-html="chevron_right"></div>
                </a>
              </div>
            </div>
          </div>
        </b-col>
        <b-col sm="6" md="6" lg="3">
          <div class="prefooter--block">
            <div class="prefooter--icon" v-html="chat"></div>
            <div class="prefooter--text">
              <div class="prefooter--title">Online chat</div>
              <div class="prefooter--link">
                <a onClick="window.zE.activate()" href="#prefooter"> Chatta ora </a>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Vue from 'vue';
import { faq, chat, whatsapp, mail, phone, phone_reverse, clock } from '@/components/svg/common';
import { chevron_right } from '@/components/svg/chevrons';

export default {
  name: 'prefooter',
  components: {},
  created() {
    this.faq = faq;
    this.chat = chat;
    this.whatsapp = whatsapp;
    this.mail = mail;
    this.phone = phone;
    this.phone_reverse = phone_reverse;
    this.clock = clock;
    this.chevron_right = chevron_right;
  },
  data() {
    return {
      config: Vue.prototype.$config,
      chat_link: '', //'javascript:window.Tawk_API.toggle()'
    };
  },
};
</script>

<style lang="scss">
.prefooter {
  margin-bottom: $grid-gutter-width;
  color: $text;
  @include font-primary-regular;
  font-size: 14px;
  .col-sm-6 {
    margin-bottom: $grid-gutter-width/2;
  }
  &--block {
    @extend .panel !optional;
    //margin-bottom:$grid-gutter-width;
    display: flex;
    padding: 22px 24px;
    height: 100%;
    align-items: center;
  }
  &--icon {
    margin-right: 0.75rem;

    svg {
      max-width: none;
    }
  }
  &--text {
    line-height: 120%;
  }
  &--title {
  }
  &--link {
    a,
    a:hover,
    a:focus {
      color: $cta;
      display: flex;
    }
  }
  @include media-breakpoint-up(md) {
    &--block {
      margin-bottom: 0;
    }
    .col-md-3 {
      //margin-bottom:$grid-gutter-width;
    }
  }
}
</style>
